import React, { useEffect, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
    Button,
    DialogActions,
    Dialog,
    DialogContent,
    IconButton,
    DialogTitle,
    Slide
} from '@material-ui/core';
import { connect } from "react-redux";
import CloseIcon from '@material-ui/icons/Close';
import { SimTrackingImg } from '../../../components/icons';
import { withRouter, useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    widthV1: {
        width: 628,
        maxWidth: 628
    },
    dialogTitleV1: {
        paddingTop: 40,
        paddingRight: 36,
        paddingLeft: 36,
        paddingBottom: '0px !important',
        "& .MuiTypography-root": {
            display: 'flex',
            justifyContent: 'center'
        }
    },
    divV1: {
        fontSize: 16,
        fontWeight: 500
    },
    divV2: {
        fontSize: 32,
        fontWeight: 500,
        marginTop: -10
    },
    divV3: {
        textAlign: 'center'
    },
    closeIcon: {
        color: 'grey',
        fontSize: 18
    },
    divCloseButton: {
        position: 'absolute',
        top: 30,
        right: 34,
    },
    dialogContentV1: {
        paddingLeft: 64,
        paddingRight: 64,
        paddingTop: 24,
        paddingBottom: '0px !important'
    },
    divV4: {
        fontSize: 20,
        textAlign: 'center',
        marginTop: 24
    },
    dialogActionsV1: {
        paddingLeft: 64,
        paddingRight: 64,
        paddingTop: 24,
        paddingBottom: '32px !important',
        display: 'flex',
        justifyContent: 'center'
    },
    buttonV1: {
        textTransform: 'capitalize',
        color: 'white',
        backgroundColor: '#5170f0',
        fontWeight: 300,
        paddingTop: 17,
        paddingBottom: 17,
        paddingRight: 96,
        paddingLeft: 96,
        borderRadius: 8,
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    paper1: {
        borderRadius: 8
    },
    imgV1: {
        width: 500,
        height: 222
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SimTrackingPopUp = ({ open, onClose, onTrack }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        localStorage.setItem('SimTrackingPopUpShown', true)
    }

    const goToSimTracking = () => {
        onTrack();
        handleClose();
    }


    return (
        <>
            <Dialog
                open={dialogOpen}
                fullWidth
                maxWidth={'sm'}
                TransitionComponent={Transition}
                keepMounted
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                onClose={handleClose}
                aria-labelledby="sim-tracking-pop-up"
                aria-describedby="sim-tracking-pop-up-description"
                classes={{ paperWidthSm: classes.widthV1, paperScrollPaper: classes.paper1 }}
            >
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV3}>
                        <div className={classes.divV1}>Introducing</div>
                        <div className={classes.divV2}>SIM Tracking</div>
                    </div>
                    <div className={classes.divCloseButton}>
                        <IconButton onClick={handleClose} >
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent className={classes.dialogContentV1}>
                    <SimTrackingImg className={classes.imgV1} />
                    <div className={classes.divV4}>Track your Trips for FREE using Driver’s SIM Card</div>
                </DialogContent>

                <DialogActions className={classes.dialogActionsV1}>
                    <Button variant="contained" className={classes.buttonV1} onClick={() => { goToSimTracking() }}>
                        Track your Trip Now
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SimTrackingPopUp);